import React from 'react';

const StepperComponent = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center mb-6">
      {[1, 2, 3].map((step) => (
        <React.Fragment key={step}>
          <div className={`flex items-center justify-center w-12 h-12 rounded-full border-2 ${
            currentStep === step
              ? 'border-[#202654] bg-[#202654] text-white'
              : currentStep > step
              ? 'border-green-500 bg-green-500 text-white'
              : 'border-gray-300 bg-white text-gray-400'
          }`}>
            <span className="text-lg font-semibold">{step}</span>
          </div>
          {step < 3 && (
            <div className={`w-32 h-1 ${currentStep > step ? 'bg-green-500' : 'bg-gray-200'}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepperComponent;
